//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import Card from './Card.vue';
import { EventBus } from '../vue/eventBus.js';

export default {
  props: ['siteUrl', 'postPerPage'],
  name: 'Programmes',
  components: { Card },
  data() {
    return {
      data: [],
      noData: false,
      loadMoreClicked: false,
      loading: false,
      navigation: true,
      currentPosts: 0,
      offset: 16,
      favourites: [],
      deelnemersOptions: [],
      totalPost: 0,
      formData: {
        offset: 0,
        deelnemers: [],
        only_favourites: false,
        post_type: [],
      },
      deelnemerTrayOpened: false,
      filtersTrayOpened: false,
      postTypes: [
        { label: 'Video\'s', value: 'video' },
        { label: 'Interviews', value: 'interview' },
        { label: 'Artikelen', value: 'article' },
        { label: 'Livestreams', value: 'live' },
        { label: 'Overig', value: 'others' },
        { label: 'Podcasts', value: 'podcast' },
        { label: 'Foto\'s', value: 'images' },
      ],
    };
  },
  computed: {
    // get the total favourite and display it on tops
    favouriteCount: function() {
      return this.favourites.length;
    },
  },
  mounted() {
    this.getURLHash();
    this.getFavouritesFromLocal();
    this.loadDeelnemers();
  },
  methods: {
    //get favourite ids from localstorage
    getFavouritesFromLocal: function() {
      if (localStorage.getItem('favourites')) this.favourites = JSON.parse(localStorage.getItem('favourites'));
    },

    getURLHash() {
      if (window.location.hash) {
        const hash = window.location.hash.substr(1);
        const splitHash = hash.split('&');
        console.log({splitHash});
        splitHash.map(item => {
          const splitParam = item.split('=');
          console.log('param', splitParam[1])
          this.formData[splitParam[0]] = splitParam[1].split(',')
        });
        this.loadProgrammes(false);
      } else {
        this.loadProgrammes(false);
      }
    },

    loadDeelnemers() {
       axios
        .get(`${this.siteUrl}/wp-json/deelnemers/v2/list`)
        .then(res => {
          this.deelnemersOptions = res.data
        });
    },

    //main function of loading posts
    loadProgrammes(loadMore = false, favourites = false) {
      if (!loadMore) {
        this.loading = true;
        this.formData.offset = 0;
        this.currentPosts = 0;
        this.navigation = true;
      } else {
        this.loadMoreClicked = true;
      }

      if (favourites) {
        this.formData.favourites = this.favourites;
      }

      //converts array to comma delimiter string for the params
      const fD = Object.entries(this.formData).reduce((newObj, [key, val]) => {
        if (
          key === 'only_favourites' ||
          key === 'offset' ||
          key === 'posts_per_page'
        ) {
          newObj[key] = val;
        } else {
          if (key.length > 0) {
            newObj[key] = val.join();
          } else {
            return;
          }
        }
        return newObj;
      }, {});

      let url =
        `${this.siteUrl}/wp-json/dpd/v2/my_meta_query`;

      axios
        .get(url, {
          params: fD,
        })
        .then(response => {
          if (response.data.message !== undefined) {
            this.noData = true;
            this.data = [];
          } else {
            this.noData = false;
            this.totalPost = response.data.total;

            console.log('data', response.data.data);


            this.currentPosts =
              this.currentPosts + this.objectLength(response.data.data);
            if (
              response.data.total <= this.offset ||
              this.currentPosts >= this.totalPost
            ) {
              this.navigation = false;
            }
            console.log('loadmore', loadMore);

            if (loadMore) {
              this.data = [...this.data, ...response.data.data];
            } else {
              this.data = response.data.data;
            }
          }

          this.loading = false;
          this.loadMoreClicked = false;
        });
    },

    toggleShowFavourite() {
      if (this.formData.only_favourites) {
        this.formData.only_favourites = false;
        this.loadProgrammes(false, false)
      } else {
        this.formData.only_favourites = true;
        this.loadProgrammes(false, true)
        this.formData.post_type = [];
      }
    },

    toggleDeelnemerTray() {
      this.deelnemerTrayOpened = !this.deelnemerTrayOpened;
    },

    toggleFiltersTray() {
      this.filtersTrayOpened = !this.filtersTrayOpened;
    },

    selectFilter(filterType, payload, isExclusive = false) {

      if (payload === 'all') {
        this.formData[filterType] = [];
      } else {

        if(isExclusive){
          // choose only one
          this.formData[filterType] = [payload];

        } else {
          const selected = this.formData[filterType].findIndex(selected => {
            return payload.toString() === selected.toString();
          });

          if (selected !== -1) {
            this.formData[filterType].splice(selected, 1);
          } else {
            this.formData[filterType].push(payload);
          }
        }
      }
      this.loadProgrammes(false);
    },


    //check if the filter is currently selected, better for this in computed?
    checkIfSelected(type, payload) {
      return this.formData[type].find(item => {
        return payload.toString() === item.toString();
      });
    },

    loadMore() {
      // console.log('loading ah...');
      this.formData.offset = this.formData.offset + parseInt(this.offset);
      this.loadProgrammes(true);
    },

    setFavourites: function(postid) {
      let favs = this.favourites;
      if (favs.length > 0) {
          const selected = favs.findIndex(selected => {
          return postid.toString() === selected.toString();
        });

        if (selected !== -1) {
            favs.splice(selected, 1);
          } else {
            favs.push(postid.toString());
          }
        } else {
          favs = [postid.toString()]
        }
      this.favourites = favs;
    },


    objectLength(object) {
      var length = 0;
      for (var key in object) {
        if (object.hasOwnProperty(key)) {
          ++length;
        }
      }
      return length;
    },

  },
  watch: {
  //watch for favourites model. will update locastorage if there is any change
		favourites: {
      handler() {
        localStorage.setItem('favourites', JSON.stringify(this.favourites));
        if (this.formData.only_favourites) {
          this.loadProgrammes(false, true);
        }
      },
  },
  //watch for changes on formData and append the hash to the URL
  formData: {
      handler() {
        const {post_type, deelnemers} = this.formData;
        // const postType = post_type.length > 0 ? post_type : 'all';
        // const deel = deelnemer.length > 0 ? deelnemer : 'all';
        const hash = `post_type=${post_type}&deelnemers=${deelnemers}`;
        window.location.hash = hash;
      },
      deep: true,
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/Programmes.vue